/** Shape of `pages.home.heroSlides` in the locale files. */

export interface HeroFlowRow {
  k: string;
  v: string;
  total?: boolean;
}

export interface HeroFlowStep {
  label: string;
  title: string;
  tag: string;
  rows: HeroFlowRow[];
  benefit: string;
  ok?: boolean;
}

export type HeroJobTone = "blue" | "amber" | "green";

export interface HeroBeforeAfterCopy {
  before: string;
  after: string;
  slider: string;
  hint: string;
  mess: string[];
  jobs: Array<{ name: string; status: string; tone: HeroJobTone }>;
  kpis: Array<{ value: string; label: string }>;
}

export interface HeroSlidesCopy {
  groupLabel: string;
  pause: string;
  play: string;
  /** "Next: {{label}}" on the compact desktop chip shown over the video. */
  next: string;
  view: string;
  videoCaption: string;
  tabs: { video: string; flow: string; beforeAfter: string };
  flow: { ariaLabel: string; steps: HeroFlowStep[] };
  beforeAfter: HeroBeforeAfterCopy;
}

export function isHeroSlidesCopy(value: unknown): value is HeroSlidesCopy {
  if (!value || typeof value !== "object") return false;
  const copy = value as Partial<HeroSlidesCopy>;
  return (
    Array.isArray(copy.flow?.steps) &&
    copy.flow.steps.length > 0 &&
    Array.isArray(copy.beforeAfter?.mess) &&
    Array.isArray(copy.beforeAfter?.jobs) &&
    typeof copy.tabs?.video === "string"
  );
}
